// Define base URLs for API and Website
export const baseURL = process.env.NODE_ENV === 'production' 
  ? 'https://api.codebreakers.online' 
  : 'http://localhost:8080';

export const URL = process.env.NODE_ENV === 'production' 
  ? 'https://codebreakers.online' 
  : 'http://localhost:3000';